import * as React from 'react';
import { BaseForm } from './Base';
import theme from '../../utils/theme';
import { ProfileContext, ProfileManager } from '../../profile';
import { useRequest, getHeaders } from '../../api/client';
import Loader from '../Loader';
import { Category } from '../../product';

type SelectProps = React.InputHTMLAttributes<HTMLSelectElement>;

export interface Props extends SelectProps {
  id: string;
  label: string;
  tooltip?: string;
  field: any;
  onValueChange: Function;
  defaultValue: any;
}

export type Option = {
  label: string;
  value: string;
};

const categories = (context: ProfileManager) => {
  const [state, _] = useRequest(() => ({
    url: '/store/categories',
    method: 'GET',
    headers: getHeaders(context),
  }));

  return state;
};

export function CategorySelect (props: Props) {
  const context = React.useContext(ProfileContext);
  const state = categories(context);

  if (state.loading) {
    return <Loader />;
  }

  return (
    <BaseForm label={props.label} id={props.id} tooltip={props.tooltip}>
      <select
        id={props.id}
        onChange={(e) => props.onValueChange(props.field, e.target.value)}
        className={theme.form.field.input}
        {...props}
      >
        <option value={null}>Please select</option>
        {state.data && state.data.map((option: Category) => (
          <option value={option.id}>{option.name} {
            option.parent_id && '(Subcategory)'
          }</option>
        ))}
      </select>
    </BaseForm>
  );
}
